import React, { useEffect, useState } from "react";
import "./styles.css";
//external or internal components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilter,
} from "@fortawesome/free-solid-svg-icons";
import { colors } from "../../common/pallette/colors";
import {
  Box,
  ClickAwayListener,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setGlobalFiltersCount,
} from "../../redux/reducers/common";
import FiltersWrapper from "./filters/filtersWrapper";
import { getClubValue, getLeagueValue, getRatingValue, getYearValue } from "../../pages/licenseAnalytics/licenseAnalyticsSupport/getLicenseAnalyticsActions";
import { SingleOption } from "../../pages/licenseAnalytics/licenseAnalyticsSupport/typeInterfaces";

const FilterBoxLicenceAnalytics = () => {
  const [isOpen, setIsOpen] = useState(false);
  const globalFiltersCount = useSelector(
    (state: any) => state.common.globalFiltersCount
  );
  const dispatch = useDispatch();
  const selectedLeagueValue: SingleOption | SingleOption[] | undefined = useSelector(getLeagueValue);
  const selectedRatingValue: SingleOption | SingleOption[] | undefined = useSelector(getRatingValue);
  const selectedYear: SingleOption | undefined | any = useSelector(getYearValue);
  const selectedClub:any = useSelector(getClubValue);
  
  useEffect(() => {
    let count: any = 0;
    selectedLeagueValue?.length > 0 && count++;
    selectedRatingValue?.length > 0 && count++;
    (selectedYear !== null && selectedYear !== undefined && Object.keys(selectedYear)?.length > 0) && count++;
    (selectedClub !== null && selectedClub !== undefined && Object.keys(selectedClub)?.length > 0) && count++;
    dispatch(setGlobalFiltersCount(count));
  }, [selectedLeagueValue, selectedRatingValue, selectedYear, selectedClub, dispatch]);

  return (
    <React.Fragment>
      <div className="filterBox" style={{ backgroundColor: colors.grey.light }}>
        <div
          className="filterButton pointer"
          onClick={() => setIsOpen(!isOpen)}
        >
          <FontAwesomeIcon className="filterIcon icon" icon={faFilter} />
          <span style={{ color: colors.grey.dark }}>Filters</span>
        </div>
        {globalFiltersCount > 0 && (
          <Box
            className={"filterCount"}
            sx={{ backgroundColor: colors.blue.navy }}
          >
            {globalFiltersCount}
          </Box>
        )}
        {isOpen && (
          <ClickAwayListener
            onClickAway={() => {
              setIsOpen(false);
            }}
          >
            <Box className="filterWrapper">
              <FiltersWrapper />
            </Box>
          </ClickAwayListener>
        )}
      </div>
    </React.Fragment>
  );
};

export default FilterBoxLicenceAnalytics;
